import { Component, OnInit, Input } from '@angular/core';
import { CompanyParamsService } from '../../../core/services/company-params.service';
import { NgStyle } from '@angular/common';
import { LazyLoadImageModule } from 'ng-lazyload-image';

@Component({
    selector: 'app-loading-cruise-left-information',
    templateUrl: './loading-cruise-left-information.component.html',
    styleUrls: ['./loading-cruise-left-information.component.scss'],
    imports: [NgStyle, LazyLoadImageModule]
})
export class LoadingCruiseLeftInformationComponent implements OnInit {

  @Input() topValue?:number;

  constructor(public companyParams: CompanyParamsService) { }

  ngOnInit(): void {
  }

}
